import React from 'react'
import { Object, Text } from '../assets/styles'

const Footer = () => {
  return (
    <Object className='Footer'>
        <Text size={1} className='semi-bold backdrop-col'>&copy; 2024 Apple Inc</Text>
    </Object>
  )
}

export default Footer